export class SlideInElementTracker {
	constructor(initiator) {
		this.initiator = initiator;
	}

	/**
	 * Track a certain action in Redshift.
	 *
	 * @param {string} action
	 * @param {string} label
	 * @param {string} property - default is null
	 * @return void
	 */

	fireTracking(action, label, property = null, value = 0) {
		if (!window.snowplow) {
			console.warn('SlideInElementTracker.fireTracking: snowplow not available on window.');
			return;
		}

		window.snowplow('trackStructEvent', {
			category: 'SlideInElement',
			action: action,
			label: label,
			property: property,
			value: value
		});
	}
}

window.SlideInElementTracker = SlideInElementTracker;
